import formatDateFns from 'date-fns/format';
import add from 'date-fns/add';
import { nlBE, fr } from 'date-fns/locale';

const locale = process.env.REACT_APP_P_STUDIO_LANGUAGE === 'fr' ? fr : nlBE;

export function formatDate(date: string) {
  if (!date) return '';

  return formatDateFns(new Date(date), 'dd/MM/yyyy');
}

export function formatDuration(
  { minutes = 0, seconds = 0 }: { minutes?: number; seconds?: number },
  format: 'HH:mm' | 'HH:mm:ss' = 'HH:mm',
) {
  const date = add(new Date(0), { minutes, seconds });

  const userTimezoneOffset = date.getTimezoneOffset() * 60000;

  return formatDateFns(new Date(date.getTime() + userTimezoneOffset), format);
}

export function formatAssignmentToDate(date: string) {
  return formatDateFns(new Date(date), 'eeeeee dd/MM', { locale });
}
